import notFoundState from "./store/not-found-state";


/* This is the syntax for creating a Vuex module of authentication proccess. */
const notFound = {
  namespaced: true,
  state: notFoundState,
};

export { notFound };
